(function() {
  var StepHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  exports.CheckboxesHandler = (function(superClass) {
    extend(CheckboxesHandler, superClass);

    function CheckboxesHandler() {
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      this.setFieldAspect = bind(this.setFieldAspect, this);
      this.getFieldAspect = bind(this.getFieldAspect, this);
      this.addValidationRules = bind(this.addValidationRules, this);
      return CheckboxesHandler.__super__.constructor.apply(this, arguments);
    }

    CheckboxesHandler.prototype.inputSel = 'button.spp-checkbox';

    CheckboxesHandler.prototype.addValidationRules = function() {
      this.validator.registerRule({
        selector: '.validate-checkbox',
        text: 'Please select one or more options',
        func: (function(_this) {
          return function(elem) {
            return !!_this.getInputEl().filter('.active').length;
          };
        })(this)
      });
      return $('.validationContainer').undelegate('.validate-checkbox', 'change');
    };

    CheckboxesHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var retval;
      retval = {
        value: this.getInputEl({
          aspect: aspectID
        }).is(':enabled.active')
      };
      return retval;
    };

    CheckboxesHandler.prototype.setFieldAspect = function(fieldAspect) {
      var input;
      input = this.getInputEl({
        aspect: fieldAspect.aspects_id
      });
      if (fieldAspect.value && input.is(':enabled')) {
        return input.addClass('active');
      } else {
        return input.removeClass('active');
      }
    };

    CheckboxesHandler.prototype.afterLoadLayout = function(sel, data) {
      CheckboxesHandler.__super__.afterLoadLayout.call(this, sel, data);
      return this.getInputEl().on('click', function() {
        var el;
        el = $(this);
        return setTimeout(function() {
          return el.change();
        });
      });

      /*
      I'm commenting this out for now because I don't think it's useful, but
      if anyone complains, then we can easily add it back. If it turns out
      nobody cares, then we should remove the button HTML from the view too.
       */
    };

    return CheckboxesHandler;

  })(StepHandler);

}).call(this);
